import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { Chip, Grid, IconButton, Skeleton, SvgIcon, Tooltip } from '@mui/material';
import { Edit as EditIcon, Delete as DeleteIcon } from '@mui/icons-material';
import avatar from './avatar.png';
import { useAppDispatch, useAppSelector } from '../../../../../app/redux/hooks';
import {
  deleteCustomer,
  getCustomersAction,
  clearCustomersAction
} from '../../../redux/reducer/deliveryTrackingSlices/customerDeliverySlice';
import { useEffect, useRef, useState } from 'react';
import './DeliveryCustomerCard.scss';
import AddCustomerDelivery from '../customerdelivery/AddCustomerDelivery';
import CustomDeletePopup from '../../../../../common/components/customdelete/CustomDeletePopup';
import constants from '../../../../../utils/constants';
import CustomButton from '../../../../../common/components/buttons/CustomButton';
import { usePagination } from '../../../../../utils/commonFunctions';
import CustomTextField from '../../../../../common/components/customized/customtextfield/CustomTextField';

import InfiniteScroll from '../../../../../common/components/infinitescroll/InfiniteScroll';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import { useForm } from 'react-hook-form';
interface CustomerCardProps {
  onScroll: (data: any) => void;
  setApi: React.Dispatch<
    React.SetStateAction<{ handlePagination: Function; fetchedData: any; count: number }>
  >;
  clearState: () => void;
}
function DeliveryCustomerCard({ onScroll, setApi, clearState }: CustomerCardProps) {
  const [rows, setRows] = useState<any>([]);
  const [filteredRow, setFilteredRow] = useState<null | any>([]);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [message, setMessage] = useState<string>('');
  const [open, setOpen] = useState<boolean>(false);

  const [isDelete, setIsDelete] = useState<boolean>(false);
  const [type, setType] = useState<string>('');
  const [role, setRole] = useState<string>('');
  const [label, setLabel] = useState('');

  const { control } = useForm();
  const { data, isLoading, count } = useAppSelector(state => state.customerGet);
  const { isLoading: deleteLoading } = useAppSelector(state => state.customerDelete);

  const { pageSize, pageNo, pagination } = usePagination(12, 1);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getCustomersAction({ pageNo, pageSize }));
    return () => {
      dispatch(clearCustomersAction());
    };
  }, []);

  useEffect(() => {
    if (data?.length > 0) {
      if (rows.length < 0) {
        setRows([...rows, ...data]);
      } else {
        const uniqueRows = data.filter(
          (item: any) => !rows.some((el: any) => el.customerId === item.customerId)
        );
        setRows([...rows, ...uniqueRows]);
      }
    }
  }, [data]);

  const handleUpdate = (params: any) => {
    setFilteredRow(params);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleDelete = async () => {
    if (filteredRow && filteredRow?.customerId) {
      await dispatch(
        deleteCustomer({ customerId: filteredRow?.customerId, pageNo: 1, pageSize: 8 })
      );
    }
    setIsDelete(false);
  };
  const handleInfinitePagination = async (pageNo: number) => {
    await dispatch(getCustomersAction({ pageNo: pageNo, pageSize: 12 }));
  };
  useEffect(() => {
    if (count !== null)
      setApi({
        handlePagination: handleInfinitePagination,
        fetchedData: rows,
        count: count
      });
  }, [count, rows]);

  const renderSkeleton = () => (
    <Grid item lg={3} md={3} sm={6} xs={12}>
      <Card className='customCard' sx={{ padding: 2, borderRadius: 2, boxShadow: 1 }}>
        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          <Skeleton variant='circular' width={80} height={80} sx={{ marginBottom: 1 }} />
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              flex: 1,
              paddingLeft: 2,
              width: '100%'
            }}
          >
            <Skeleton variant='text' width={100} height={24} sx={{ marginBottom: 1 }} />
            <Skeleton variant='text' width={100} height={24} sx={{ marginBottom: 1 }} />
          </Box>
        </Box>
      </Card>
    </Grid>
  );

  return (
    <Box>
      <Box
        className='customer-title'
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          width: '100%',
          gap: 2
        }}
      >
        <Box sx={{ width: 200 }}>
          <CustomTextField
            name='search'
            control={control}
            id='filter-input'
            placeholder='Search...'
            variant='standard'
            icon={<SearchOutlinedIcon color='primary' />}
          />
        </Box>
        <CustomButton
          category={'Add Customer'}
          className='saveChanges'
          onClick={() => {
            setOpen(true);
            setRole('Add Customer');
            setFilteredRow(null);
            setType('Add Customer');
            setLabel('Add Customer');
          }}
        />
      </Box>
      <Box sx={{ height: '70vh', overflowY: 'auto' }} onScroll={e => onScroll(e.target)}>
        <Grid container spacing={2}>
          {isLoading && rows.length === 0
            ? Array.from({ length: 4 }).map((_, index) => renderSkeleton()) // Render 4 skeleton cards
            : rows.map((item: any, index: any) => (
                <Grid item lg={3} md={3} sm={6} xs={12} key={index}>
                  <Card className='customCard' key={item}>
                    <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                      <Grid item lg={4} md={4} sm={4} xs={4} key={index}>
                        <Box className='customBox'>
                          {/* <CardMedia
                            component='img'
                            sx={{ width: 80 }}
                            image={avatar}
                            alt='Live from space album cover'
                          /> */}

                          {/* <Box
                            sx={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              width: 56,
                              height: 56,
                              borderRadius: '50%',
                              boxShadow: 2,
                              background:
                                'linear-gradient(to right, #3239ea6e, #e5e9a2c4)',
                              transition: 'transform 0.3s, background 0.3s',
                              '&:hover': {
                                background:
                                  'linear-gradient(to right, #e5e9a2c4, #3239ea6e)',
                                cursor: 'pointer',
                                transform: 'scale(1.1)',
                                '.svg': {
                                  fill: 'white'
                                }
                              }
                            }}
                          >
                            {/* <SvgIcon
                              sx={{
                                width: 28,
                                height: 28,
                                fill: 'gray'
                              }}
                              className='svg'
                              viewBox='0 0 15 15'
                            >
                              <path d='M7.5 0.875C5.49797 0.875 3.875 2.49797 3.875 4.5C3.875 6.15288 4.98124 7.54738 6.49373 7.98351C5.2997 8.12901 4.27557 8.55134 3.50407 9.31167C2.52216 10.2794 2.02502 11.72 2.02502 13.5999C2.02502 13.8623 2.23769 14.0749 2.50002 14.0749C2.76236 14.0749 2.97502 13.8623 2.97502 13.5999C2.97502 11.8799 3.42786 10.7206 4.17091 9.9883C4.91536 9.25463 6.02674 8.87499 7.49995 8.87499C8.97317 8.87499 10.0846 9.25463 10.8291 9.98831C11.5721 10.7206 12.025 11.8799 12.025 13.5999C12.025 13.8623 12.2376 14.0749 12.5 14.0749C12.7623 14.075 12.975 13.8623 12.975 13.6C12.975 11.72 12.4778 10.2794 11.4959 9.31166C10.7244 8.55135 9.70025 8.12903 8.50625 7.98352C10.0187 7.5474 11.125 6.15289 11.125 4.5C11.125 2.49797 9.50203 0.875 7.5 0.875ZM4.825 4.5C4.825 3.02264 6.02264 1.825 7.5 1.825C8.97736 1.825 10.175 3.02264 10.175 4.5C10.175 5.97736 8.97736 7.175 7.5 7.175C6.02264 7.175 4.825 5.97736 4.825 4.5Z' />
                            </SvgIcon> */}
                          {/* </Box> */}

                          <Box
                            sx={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              width: 56,
                              height: 56,
                              borderRadius: '50%',
                              backgroundColor: '#ffff',
                              marginX: 'auto',
                              '&:hover': {
                                backgroundColor: '#1976d2cc',
                                cursor: 'pointer',
                                transform: 'scale(1.01)',
                                transition: 'transform 1.5s, background 1.6s',
                                '.svg': {
                                  fill: '#ffff'
                                }
                              }
                            }}
                          >
                            <SvgIcon
                              sx={{
                                width: 48,
                                height: 48,
                                color: '#1976d2cc',
                                darkMode: { color: '#A5B4FC' }
                              }}
                              className='svg'
                              viewBox='0 0 16 16'
                            >
                              <path d='M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z' />
                            </SvgIcon>
                          </Box>

                          <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                            <IconButton
                              sx={{ color: 'primary.main' }}
                              aria-label='edit'
                              onClick={() => {
                                setType(`Update Customer`);
                                setOpen(true);
                                handleUpdate(item);
                              }}
                            >
                              <EditIcon sx={{ fontSize: 18, color: '#ffc60a' }} />
                            </IconButton>
                            <IconButton
                              sx={{ color: 'error.main' }}
                              aria-label='edit'
                              onClick={() => {
                                setIsDelete(true);
                                setFilteredRow(item);
                                setMessage(
                                  `${constants.DeleteCustomer} ${item.customerName} ?`
                                );
                              }}
                            >
                              <DeleteIcon sx={{ fontSize: 18, color: '#d32f2fe8' }} />
                            </IconButton>
                          </Box>
                        </Box>
                      </Grid>
                      <Grid item lg={8} md={8} sm={8} xs={8} key={index}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', flex: '1' }}>
                          <CardContent
                            sx={{
                              display: 'flex',
                              flexDirection: 'column',
                              justifyContent: 'center',
                              height: '128px',
                              padding: ' 16px',
                              paddingBottom: '0px !important',
                              paddingTop: ' 0px !important'
                            }}
                          >
                            <Typography
                              variant='subtitle1'
                              component='div'
                              className='header-name'
                            >
                              {item.customerName
                                ? item.customerName.charAt(0).toUpperCase() +
                                  item.customerName.slice(1)
                                : ''}
                            </Typography>
                            <Tooltip title={item.deliveryAddress}>
                              <Typography
                                className='typoAddress'
                                color='text.secondary'
                                component='div'
                                sx={{ fontSize: '12px' }}
                              >
                                {item.deliveryAddress.length > 50
                                  ? `${item.deliveryAddress.slice(0, 50)}...`
                                  : item.deliveryAddress}
                              </Typography>
                            </Tooltip>

                            <Chip
                              label={item.contactNumber}
                              variant='outlined'
                              className='typoContact'
                              sx={{ fontSize: '12px', height: '20px', padding: '0 10px' }}
                            />
                          </CardContent>
                        </Box>
                      </Grid>
                    </Box>
                  </Card>
                </Grid>
              ))}
          {open && (
            <AddCustomerDelivery
              open={open}
              setOpen={setOpen}
              roleType={type}
              filteredRow={filteredRow}
            />
          )}
          {isDelete && (
            <CustomDeletePopup
              open={isDelete}
              setOpen={setIsDelete}
              handleDelete={handleDelete}
              handleClose={handleClose}
              message={message}
              isLoading={deleteLoading}
            />
          )}
        </Grid>
      </Box>
    </Box>
  );
}
export default InfiniteScroll(DeliveryCustomerCard);

// -----
